export const Small = {
  fontSize: {
    xs: '14px',
    md: '16px',
    xl: '18px'
  },
  lineHeight: {
    xs: '20px',
    md: '24px',
    xl: '26px'
  }
};